import React, { useState, Fragment } from 'react';
import classNames from 'classnames';

import { FieldContainer, FieldContainerProps } from './FieldContainer';
import { FieldStyles } from './styles/FieldStyles';

import { FieldWrapperProps } from 'components/fields/FieldWrapper';

export type TextFieldProps = FieldContainerProps &
    FieldWrapperProps &
    React.InputHTMLAttributes<HTMLInputElement> & {
        inputRef?: React.Ref<HTMLInputElement>;
    };

export const TextField = (props: TextFieldProps) => {
    const { label, error, className, inputRef, required, footer, ...inputProps } = props;

    return (
        <FieldContainer label={label} error={error} required={required} footer={footer}>
            <input
                className={classNames(FieldStyles.field, className, { error: Boolean(error) })}
                ref={inputRef}
                {...inputProps}
            />
        </FieldContainer>
    );
};

export interface TextFieldSecuredProps extends TextFieldProps {}

export const TextFieldSecured = (props: TextFieldSecuredProps) => {
    const { label, error, className, inputRef, ...inputProps } = props;
    const [isSecure, setIsSecure] = useState<boolean | undefined>(true);

    return (
        <FieldContainer label={label} error={error}>
            <Fragment>
                <input
                    className={classNames(FieldStyles.field, className, 'toggle-space', {
                        error: Boolean(error),
                    })}
                    ref={inputRef}
                    type={isSecure ? 'password' : 'text'}
                    {...inputProps}
                />
                <button
                    aria-label={isSecure ? 'Password is hidden' : 'Password is shown'}
                    aria-pressed={!isSecure}
                    onClick={() => setIsSecure(!isSecure)}
                    className={FieldStyles.showHide}
                    type="button"
                >
                    {isSecure ? 'SHOW' : 'HIDE'}
                </button>
            </Fragment>
        </FieldContainer>
    );
};
